$shm_hitalama_map_touch $mol_touch
	Map_page $shm_hitalama_map_page
	allow_wheel_zoom true
	tool_active false
	tool_cancel null
